<!--
 * @Descripttion: 活动详情
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 16:07:58
-->
<template>
    <div class="cultural-activities-details--page">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/user-center' }">
                            <i class="icon-home"></i> 个人中心
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/work-portal/cultural-activities' }">
                            企业文化
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>活动详情</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header>
            <div class="center-context">
                <div>
                    <cultural-item></cultural-item>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CulturalItem from "./components/cultural-item.vue";
export default {
    name: "CulturalActivitiesDetails",
    components: {
        CulturalItem,
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
